import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaternityLeave = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "maternityLeave",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Path_12479",
		"data-name": "Path 12479",
		d: "M21,9.333A5.418,5.418,0,0,0,15.5,4,5.418,5.418,0,0,0,10,9.333a2.112,2.112,0,0,0,2,2.21,2.113,2.113,0,0,0,2-2.21A5.418,5.418,0,0,0,8.5,4,5.418,5.418,0,0,0,3,9.333C3,15.373,10.222,20,12,20S21,15.373,21,9.333Z",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12480",
		"data-name": "Path 12480",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgMaternityLeave;
